export default class extends HTMLElement {
  connectedCallback () {
    this.connectedAt = Date.now()
    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

    this.form.addEventListener('submit', this.onSubmit)

    const timezoneInput = this.form.querySelector('input[name="timezone"]')

    if (timezoneInput) {
      timezoneInput.value = this.timezone
    }
  }

  onSubmit = (e) => {
    e.preventDefault()

    this.submitButton.disabled = true

    const body = new FormData(this.form)

    body.set('token', window.btoa(['docuseal', 'contact', 'form'].join('-')))
    body.set('elapsed', Math.round((Date.now() - this.connectedAt) / 1000))

    fetch(this.submitUrl, {
      method: 'POST',
      body
    }).then(async (resp) => {
      const html = await resp.text()

      const el = document.createElement('div')
      el.innerHTML = html

      document.body.append(el.children[0])
    }).finally(() => {
      this.submitButton.disabled = false
    })
  }

  get submitUrl () {
    const path = ['/con', 'tacts'].join('')

    if (['www.docuseal.com', 'docuseal.com'].includes(window.location.hostname) && this.timezone.startsWith('Europe/')) {
      return `https://console.docuseal.eu${path}`
    }

    return path
  }

  get form () {
    return this.querySelector('form')
  }

  get submitButton () {
    return this.querySelector('button[type="submit"]')
  }
}
